import { UiState } from '../managers/UIManager'
import BottomNav from './BottomNav'
import HomeScreen from '../screens/HomeScreen'
import ExploreScreen from '../screens/ExploreScreen'
import CollectionsScreen from '../screens/CollectionsScreen'
import ShopScreen from '../screens/ShopScreen'
import ProfileScreen from '../screens/ProfileScreen'

interface Props {
  state: UiState
  setUiState: (fn: (prev: UiState) => UiState) => void
}

export default function AppShell({ state, setUiState }: Props) {
  const { activeTab } = state

  const setTab = (tab: UiState['activeTab']) =>
  setUiState((prev) => ({
    ...prev,
    activeTab: tab,
    tabTapKey: prev.tabTapKey + 1,
  }))


  return (
    <div className="app-shell">
      <div className="app-screens">
        <div style={{ display: activeTab === 'home' ? 'flex' : 'none', flexDirection: 'column', height: '100%' }}>
          <HomeScreen state={state} setTab={setTab} />
        </div>
        <div style={{ display: activeTab === 'explore' ? 'flex' : 'none', flexDirection: 'column', height: '100%' }}>
          <ExploreScreen state={state} setTab={setTab} />
        </div>
        <div style={{ display: activeTab === 'scan' ? 'flex' : 'none', flexDirection: 'column', height: '100%' }}>
          <CollectionsScreen />
        </div>
        <div style={{ display: activeTab === 'shop' ? 'flex' : 'none', flexDirection: 'column', height: '100%' }}>
          <ShopScreen />
        </div>
        <div style={{ display: activeTab === 'profile' ? 'flex' : 'none', flexDirection: 'column', height: '100%' }}>
          <ProfileScreen />
        </div>
      </div>

      <BottomNav activeTab={activeTab} onTabChange={setTab} />
    </div>
  )
}
